import { HttpService } from '~/services/Http.service'
import { HttpErrorService } from '~/services/HttpError.service'
import type { Compilation } from '~/models'
import { serviceErrorHandbook } from '@/models'

export class CompilationService {
  private httpService: HttpService
  private httpErrorService: HttpErrorService<keyof typeof serviceErrorHandbook>
  private endpoint = '/compilations'

  constructor(httpService: HttpService) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(
      serviceErrorHandbook,
      'compilation',
    )
  }

  async getById(id: number, pageSize?: number) {
    const url = [this.endpoint, id].join('/')

    return await this.httpService
      .get<Compilation>(url, {
        fetchConfig: { params: { pageSize } },
        requestConfig: {
          cancellable: true,
          needCancelAtChangeRoute: true,
          forceRequest: true,
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }
}
